// extracted by mini-css-extract-plugin
export default {"wrapper":"Heading_wrapper__NV8M3"};